import React, { createContext, useState, useContext } from 'react';

const HeaderContext = createContext({
  header: "Membership",
  setHeader: (header: string) => {}
});

interface HeaderProviderInterface{
    children: React.ReactNode
}

export const HeaderProvider: React.FC<HeaderProviderInterface> = ({ children }) => {
  const [header, setHeader] = useState("Membership");
  return (
    <HeaderContext.Provider value={{ header, setHeader: setHeader }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => useContext(HeaderContext);